import { render, staticRenderFns } from "./chatServer.vue?vue&type=template&id=1d5b58ef&scoped=true&"
import script from "./chatServer.vue?vue&type=script&lang=js&"
export * from "./chatServer.vue?vue&type=script&lang=js&"
import style0 from "./chatServer.vue?vue&type=style&index=0&id=1d5b58ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b58ef",
  null
  
)

export default component.exports